import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { SegmentsApi } from '../../api/segments.api';
import { withRequestStatus } from '../../../global/store/features/request-status.feature';
import { inject } from '@angular/core';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { switchMap, tap } from 'rxjs';
import {
  SegmentContract,
  SegmentUsageContract,
  UpdateSegmentContract,
} from './types';

type segmentsState = {
  segments: SegmentContract[] | undefined;
  segmentUsage: SegmentUsageContract[] | undefined;
};

const initialState: segmentsState = {
  segments: undefined,
  segmentUsage: undefined,
};

export const SegmentsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withRequestStatus(['getSegments', 'updateSegments', 'getSegmentUsage']),
  withMethods((store, segmentsApi = inject(SegmentsApi)) => ({
    getSegments: rxMethod<{
      salesOrganizationId: string;
      clusterId: string;
    }>(
      switchMap(({ salesOrganizationId, clusterId }) => {
        return segmentsApi.getSegments(salesOrganizationId, clusterId).pipe(
          store.handleActionPipe('getSegments', undefined),
          tap((segments) => {
            patchState(store, { segments });
          }),
        );
      }),
    ),
    updateSegmentPriorities: rxMethod<{
      salesOrganizationId: string;
      clusterId: string;
      segments: UpdateSegmentContract[];
    }>(
      switchMap(({ salesOrganizationId, clusterId, segments }) => {
        return segmentsApi
          .updateSegments(salesOrganizationId, clusterId, segments)
          .pipe(
            store.handleActionPipe('updateSegments', undefined),
            tap((segments) => {
              patchState(store, { segments });
            }),
          );
      }),
    ),
    getSegmentUsage: rxMethod<{
      salesOrganizationId: string;
      clusterId: string;
    }>(
      switchMap(({ salesOrganizationId, clusterId }) => {
        return segmentsApi.getSegmentUsage(salesOrganizationId, clusterId).pipe(
          store.handleActionPipe('getSegmentUsage', undefined),
          tap((segmentUsage) => {
            patchState(store, { segmentUsage });
          }),
        );
      }),
    ),
  })),
);
